/* eslint-disable no-unused-expressions */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import { gaWrapper } from 'helpers/analytics';
import Image from 'components/Image';
import PlayingXIPopup from './PlayingXIPopup';
import s from './MatchCornerWidget.scss';
import PopupPortal from '../../mobile/PopupPortal/PopupPortal';

const customOnError = e => {
  e.target.onerror = null;
  e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
};
const defaultThumb =
  'https://static.toiimg.com/thumb/msid-81945120,width-100,height-100/81945120.jpg';

function getPlayerList(listitem = [], thumbslist, props) {
  return listitem.map((player, index) => {
    let playerkey = player.name && player.name.split(' (')[0];
    playerkey =
      (playerkey &&
        playerkey
          .split(' ')
          .join('-')
          .toUpperCase()) ||
      null;
    // console.log('thumb list>>>', thumbslist);
    return (
      index < 3 && (
        <li>
          <Link
            to={`https://timesofindia.indiatimes.com${player.link}`}
            title={player.name}
            data-newga={`click#playingXI_timesofindia.indiatimes.com${
              player.link
            }${props.gaCategory ? `#${props.gaCategory}` : ''}`}
          >
            <span>
              {playerkey &&
              thumbslist[playerkey] &&
              thumbslist[playerkey].strimg ? (
                <Image
                  key={thumbslist[playerkey].playernameseo}
                  src={thumbslist[playerkey].strimg}
                  placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                  alt={thumbslist[playerkey].playernameseo}
                  lazyload
                  onError={customOnError}
                  offsetVertical={200}
                />
              ) : (
                <Image
                  key="default_1"
                  src={defaultThumb}
                  placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                  alt="default"
                  lazyload
                  onError={customOnError}
                  offsetVertical={200}
                />
              )}
            </span>
            <p>{player.name}</p>
          </Link>
        </li>
      )
    );
  });
}

function MatchCornerWidget(props) {
  const { data: maindata } = props;
  let { playerthumbs, playingeleven, headtohead } = maindata;
  const showplayingeleven =
    playingeleven && playingeleven.data && playingeleven.data.length > 0;
  const showheadToHead =
    headtohead && headtohead.teams && headtohead.teams.length > 0;
  if (showheadToHead) {
    // this check is just for showing team order same as miniscorecard widget
    if (
      showplayingeleven &&
      playingeleven.data[0].team_name.toLowerCase() ===
        headtohead.teams[1].short_name.toLowerCase()
    ) {
      headtohead.team1 = headtohead.teams[1];
      headtohead.team2 = headtohead.teams[0];
    } else {
      headtohead.team1 = headtohead.teams[0];
      headtohead.team2 = headtohead.teams[1];
    }
  } else {
    headtohead = undefined;
  }
  let venue = '';
  let venueimg = '';
  let firstSquad = {};
  let firstTeamName = '';
  let firstTeamPlayers = [];
  let secondSquad = {};
  let secondTeamName = '';
  let secondTeamPlayers = [];

  try {
    if (playingeleven && playingeleven.venue) {
      venue = playingeleven.venue;
    }
    if (playingeleven && playingeleven.venueimg) {
      venueimg = playingeleven.venueimg;
    }
    if (showplayingeleven) {
      firstSquad = playingeleven.data[0];
      firstTeamPlayers = (firstSquad && firstSquad.squad_array) || [];
      firstTeamName = (firstSquad && firstSquad.team_name) || '';
      secondSquad = playingeleven.data[1];
      secondTeamPlayers = (secondSquad && secondSquad.squad_array) || [];
      secondTeamName = (secondSquad && secondSquad.team_name) || '';
    }
  } catch (e) {
    playingeleven = undefined;
    playerthumbs = undefined;
  }

  const [showPopup, setPopupState] = useState(false);
  const [currTab, setcurrTab] = useState('first');
  const onSeeAllClick = event => {
    const { classList } = event.target;
    if (
      classList.contains('playingxi-seeall') ||
      classList.contains('playerpopupclose') ||
      classList.contains('playerpopup')
    ) {
      event.stopPropagation();
      setPopupState(!showPopup);
      if (classList.contains('playingxi-seeall')) {
        gaWrapper(
          'send',
          'event',
          props.gaCategory,
          'click',
          'playingXI_seeAll',
        );
        classList.contains('first-tab') && setcurrTab('first');
        classList.contains('second-tab') && setcurrTab('second');
      }
      !showPopup && document.body.classList.add('disable-scroll');
      showPopup && document.body.classList.remove('disable-scroll');
    }
  };

  return (
    <>
      {showplayingeleven || showheadToHead ? (
        <div className={s.csvenueouter} data-scrollga="scroll#playingXI_view">
          <h3>Match Statistics</h3>
          {showheadToHead && (
            <div className={s.headtohead}>
              <div className={s.headerTop}>
                <span className={s.title}>
                  Head to Head in {headtohead.matchtype}
                </span>
                <span className={s.total}>
                  Total Matches {headtohead.team1.matches_played}
                </span>
              </div>
              <div className={s.teamsList}>
                <div className={`${s.teamname} ${s.first}`}>
                  <Link
                    to={headtohead.team1.profileLink}
                    target="_blank"
                    className={`${s.team} ${s.icon} ${
                      s[headtohead.team1.short_name]
                    }`}
                  />
                  <span className={s.count}>{headtohead.team1.won}</span>
                </div>
                <div className={`${s.teamname} ${s.second}`}>
                  <span className={s.count}>{headtohead.team2.won}</span>
                  <Link
                    to={headtohead.team2.profileLink}
                    target="_blank"
                    className={`${s.team} ${s.icon} ${
                      s[headtohead.team2.short_name]
                    }`}
                  />
                </div>
              </div>
            </div>
          )}
          {/* Venue sports liveblog */}
          {(venue || venueimg) && (
            <div className={s.csvenue}>
              {venue && (
                <>
                  <h4>Venue</h4>
                  <h5>{venue}</h5>
                </>
              )}
              {venueimg && (
                <div className={s.venueimgbox}>
                  <Image
                    key={venue}
                    src={venueimg}
                    placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                    alt={venue}
                    lazyload
                    onError={customOnError}
                    offsetVertical={200}
                  />
                </div>
              )}
            </div>
          )}
          {/* Venue sports First Team Players */}
          {showplayingeleven && firstSquad ? (
            <div className={s.csplayingeleven}>
              <h4>{firstTeamName.toUpperCase()} PLAYING XI</h4>
              <div className={s.csplayingelevenscroller}>
                <ul>
                  {getPlayerList(
                    firstTeamPlayers,
                    (playerthumbs && playerthumbs.data) || {},
                    props,
                  )}
                </ul>
              </div>
              <div className={s.csseeall}>
                <Link
                  href="javascript: void(0)"
                  title="See All PlayingXI"
                  onClick={onSeeAllClick}
                  className="playingxi-seeall first-tab"
                  data-newga={`click#playingXI_seeAll${
                    props.gaCategory ? `#${props.gaCategory}` : ''
                  }`}
                >
                  See All
                </Link>
              </div>
            </div>
          ) : null}
          {/* Venue sports Second Team Players */}
          {showplayingeleven && secondSquad ? (
            <div className={s.csplayingeleven}>
              <h4>{secondTeamName.toUpperCase()} PLAYING XI</h4>
              <div className={s.csplayingelevenscroller}>
                <ul>
                  {getPlayerList(
                    secondTeamPlayers,
                    (playerthumbs && playerthumbs.data) || {},
                    props,
                  )}
                </ul>
              </div>
              <div className={s.csseeall}>
                <Link
                  href="javascript: void(0)"
                  title="See All PlayingXI"
                  onClick={onSeeAllClick}
                  className="playingxi-seeall second-tab"
                  data-newga={`click#playingXI_seeAll${
                    props.gaCategory ? `#${props.gaCategory}` : ''
                  }`}
                >
                  See All
                </Link>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
      {/* Playing XI Popup RHS */}
      {showPopup ? (
        <PopupPortal usePopupPortal={props.usePopupPortal}>
          <PlayingXIPopup
            showPopup={showPopup}
            data={maindata}
            handleClick={onSeeAllClick}
            currTab={currTab}
            thumbslist={(playerthumbs && playerthumbs.data) || {}}
            gaCategory={props.gaCategory}
          />
        </PopupPortal>
      ) : null}
    </>
  );
}

MatchCornerWidget.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
  usePopupPortal: PropTypes.bool,
};

MatchCornerWidget.defaultProps = {
  usePopupPortal: false,
};

export default MatchCornerWidget;
